<div class="home-card">
    <ng-container *ngIf="!isLoading; else skeleton">
        <div class="title">
            <h3>{{ 'home.widgetProgress.title' | translate }}</h3>
            <a tabindex="0" (click)="goToWelcomePage()">{{ 'home.widgetProgress.seeAll' | translate }}
                <i class="pi pi-angle-right"></i>
            </a>
        </div>

        <div class="percentage">
            <p class="bold-info">{{ welcomePercentage }}%</p>
            <progress value="{{ welcomePercentage }}" max="100"></progress>
        </div>

        <hr *ngIf="welcomePercentage < 75" />

        <div class="steps" *ngIf="welcomePercentage < 75">
            <h3>{{ 'home.widgetProgress.nextSteps' | translate }}</h3>

            <ng-container *ngFor="let step of getVisibleSteps(steps$ | async)">
                <div *ngIf="!step.completed">
                    <a tabindex="0" (click)="onAction(step)">👉 {{ step.title | translate }}</a>
                    <a tabindex="0" class="pi pi-book" *ngIf="(step.ressource | translate) !== ''" (click)="openResource(step)"></a>
                </div>
            </ng-container>
        </div>
    </ng-container>

<!-- SKELETON -->

    <ng-template #skeleton>
        <div class="title">
            <h3>{{ 'home.widgetProgress.title' | translate }}</h3>
            <a>{{ 'home.widgetProgress.seeAll' | translate }}
                <i class="pi pi-angle-right"></i>
            </a>
        </div>

        <div class="percentage">
            <p class="bold-info">
                <p-skeleton width="4rem" height="2.4rem"></p-skeleton>
            </p>
            <p-skeleton width="100%" height="22px"></p-skeleton>
        </div>

        <hr />

        <div class="steps w-100">
            <h3>{{ 'home.widgetProgress.nextSteps' | translate }}</h3>
                <p-skeleton width="100%"></p-skeleton>
                <p-skeleton width="100%"></p-skeleton>
                <p-skeleton width="100%"></p-skeleton>
            
        </div>
    </ng-template>
</div>